import { SAME_TAB_TARGET } from './constants'
import type { DynamicPageLinkData } from './linksDataTypes'
import { addAnchorsData, addRelToLinkProps } from './linkUtils'
import type { Link } from '@wix/public-schemas'

export type DynamicPageLinkExtraData = {
	externalBaseUrl: string
	routerIdToPrefix: Record<string, string>
}

const getInnerRouteSuffix = (innerRoute?: string) => innerRoute && innerRoute.replace(/^\//, '')

export const resolveDynamicPageLink = (externalBaseUrl: string, innerRoute: string, prefix: string): string => {
	const innerRouteSuffix = getInnerRouteSuffix(innerRoute)
	return innerRouteSuffix ? `${externalBaseUrl}/${prefix}/${innerRouteSuffix}` : `${externalBaseUrl}/${prefix}`
}

export const handleDynamicPageLink = (linkData: DynamicPageLinkData, extraData: DynamicPageLinkExtraData): Link => {
	const { externalBaseUrl, routerIdToPrefix } = extraData
	const { routerId, anchorDataId, rel, innerRoute } = linkData
	const linkToHomePage = { href: externalBaseUrl, target: '_self' } as Link
	const prefix = routerId && routerIdToPrefix[routerId]

	const baseLinkProps = {
		id: linkData.id,
		href: resolveDynamicPageLink(externalBaseUrl, innerRoute, prefix),
		target: SAME_TAB_TARGET,
	} as Link

	const linkPropsWithAnchorsData = addAnchorsData(baseLinkProps, anchorDataId)
	const linkPropsWithRel = addRelToLinkProps(linkPropsWithAnchorsData, rel)

	return prefix ? linkPropsWithRel : linkToHomePage
}
